import { render, staticRenderFns } from "./OptimizationResult.vue?vue&type=template&id=33533a5c&scoped=true"
import script from "./OptimizationResult.vue?vue&type=script&lang=js"
export * from "./OptimizationResult.vue?vue&type=script&lang=js"
import style0 from "./OptimizationResult.vue?vue&type=style&index=0&id=33533a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33533a5c",
  null
  
)

export default component.exports